import Swal from 'sweetalert2'

export default {
    install(Vue) {

        Vue.prototype.$httpError = function(options) {

            console.log(options);


            // Request aborted error : do not alert
            if (options.error.message == "Request aborted")
            {
                console.log(options.error);
                return true;
            }

            // unknow error
            if (options.error == undefined)
            {
                var httpResponse = "Erreur inconnue";
            }
            // dropzone sometimes send error() method with a string
            else if (typeof options.error == "string")
            {
                var httpResponse = options.error;
            }
            else {
                // axios
                if (options.error.isAxiosError != undefined && options.error.isAxiosError == true)
                {
                    var httpResponse = options.error.response.data;
                }
                // js error
                else if (options.error.lineNumber != undefined && options.error.message != undefined)
                {
                    var httpResponse = options.error.message;
                }
                else
                {
                    var httpResponse = (options.error.data != undefined && options.error.version == undefined ) ? options.error.data : options.error;
                }
            }

            var errorData = [];

            // if string error
            if (typeof httpResponse == "string")
            {
                errorData.push(['Erreur', httpResponse]);
            }
            // if PHP error
            else if (httpResponse.message != undefined && httpResponse.exception != undefined && httpResponse.line != undefined)
            {
                errorData.push(['Source', 'PHP']);
                errorData.push(['Message', httpResponse.message]);
                errorData.push(['Exception', httpResponse.exception]);
                errorData.push(['Line', httpResponse.line]);
            }
            else if (httpResponse.data.version != undefined && httpResponse.data.code != undefined && httpResponse.data.status != undefined && httpResponse.data.data != undefined)
            {
                // if core api error
                if (httpResponse.data.message == 'core_api_error')
                {
                    errorData.push(['Source', 'Core API']);
                    errorData.push(['Version', httpResponse.data.version]);
                    errorData.push(['Code', httpResponse.data.code]);
                    errorData.push(['Statut', httpResponse.data.status]);
                    errorData.push(['Message', httpResponse.data.data[0].message]);
                    errorData.push(['Détails', JSON.stringify(httpResponse.data.data[0].data)]);
                }

            }
            // if back office error
            else
            {
                errorData.push(['Source', 'Backoffice API']);
                errorData.push(['Version', httpResponse.version]);
                errorData.push(['Code', httpResponse.code]);
                errorData.push(['Statut', httpResponse.status]);
                errorData.push(['Message', httpResponse.message]);
                errorData.push(['Détails', JSON.stringify(httpResponse.data)]);
            }

            var html = "<div style='text-align:left'><ul>";
            errorData.forEach(function(line) {
                html += "<li><b>" + line[0] + "</b> : " + line [1] + "</li>";
            });
            html += "</ul></div>";

            Swal.fire({
                title: "Erreur",
                html: html,
                icon: 'error',
                confirmButtonText: 'Fermer',
                confirmButtonColor: 'gray',
            });
        }
    }
}
